const partnerlogos = document.querySelectorAll(`.partnerlogo-item`) || [];

function change_image_color(link){
    //alert(link.className);
    const color = [...link.querySelectorAll('.color')];

    color[0].style.display = "block";

    const gray = [...link.querySelectorAll('.gray')];

    gray[0].style.display = "none";

}

function change_image_gray(link){
    //alert(link.className);
    const color = [...link.querySelectorAll('.color')];

    color[0].style.display = "none";

    const gray = [...link.querySelectorAll('.gray')];

    gray[0].style.display = "block";

}

[...partnerlogos].forEach((logo) => {
    const color = [...logo.querySelectorAll('.color')];

    color[0].style.display = "none";

    const link = [...logo.querySelectorAll('.partnerlogolink')];

    link[0].addEventListener('mouseover', function(){change_image_color(link[0]);}, false);
    link[0].addEventListener('mouseleave', function(){change_image_gray(link[0]);}, false);
});

export default {};